import React from "react";

const PencilIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g>
        <g>
          <path
            d="M-0.707108 -0.707106C-1.09763 -0.316584 -1.09763 0.316587 -0.707106 0.707108L3.29289 4.7071C3.68342 5.09762 4.31659 5.09762 4.70711 4.7071C5.09763 4.31658 5.09763 3.6834 4.70711 3.29288L0.707106 -0.707108C0.316584 -1.09763 -0.316587 -1.09763 -0.707108 -0.707106Z"
            fillRule="evenodd"
            transform="matrix(1 0 0 1 15.4998 4.49951)"
            fill="rgb(255, 255, 255)"
          />
          <path
            d="M0.292914 13.2924L14.2928 -0.707118Q14.3625 -0.776757 14.4444 -0.831472Q14.5263 -0.886188 14.6173 -0.923877Q14.7082 -0.961567 14.8048 -0.980782Q14.9014 -0.999997 14.9999 -1Q15.0984 -1 15.195 -0.980793Q15.2916 -0.961582 15.3826 -0.923898Q15.4736 -0.886213 15.5555 -0.831502Q15.6374 -0.776791 15.707 -0.707155L19.7071 3.29234Q19.7767 3.36198 19.8314 3.44387Q19.8861 3.52576 19.9238 3.61675Q19.9615 3.70774 19.9808 3.80434Q20 3.90094 20 3.99943Q20 4.09792 19.9808 4.19452Q19.9616 4.29112 19.9239 4.38212Q19.8862 4.47312 19.8315 4.55501Q19.7768 4.63691 19.7072 4.70656L5.7071 18.7066Q5.49301 18.9207 5.19611 18.9801L0.196116 19.9801Q0.0995375 19.9994 0.0010462 19.9995Q-0.0974451 19.9996 -0.194064 19.9805Q-0.290683 19.9614 -0.381717 19.9238Q-0.47275 19.8862 -0.5547 19.8315Q-0.63665 19.7769 -0.706367 19.7073Q-0.776083 19.6378 -0.830888 19.5559Q-0.885692 19.4741 -0.923479 19.3831Q-0.961265 19.2922 -0.980581 19.1956Q-1.0198 18.9995 -0.98058 18.8034L0.0194297 13.8034Q0.078811 13.5065 0.292914 13.2924ZM1.70711 14.7066L1.00001 13.9995L1.98059 14.1956L0.98058 19.1956L0 18.9995L-0.196116 18.0189L4.80388 17.0189L5 17.9995L4.29289 17.2924L18.2929 3.29239L19 3.9995L18.2929 4.70666L14.2929 0.707155L14.9999 0L15.707 0.707118L1.70711 14.7066Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 2.99975 2)"
            fill="rgb(255, 255, 255)"
          />
          <path
            d="M-0.707108 -0.707106C-1.09763 -0.316584 -1.09763 0.316587 -0.707106 0.707108L3.29289 4.7071C3.68342 5.09762 4.31659 5.09762 4.70711 4.7071C5.09763 4.31658 5.09763 3.6834 4.70711 3.29288L0.707106 -0.707108C0.316584 -1.09763 -0.316587 -1.09763 -0.707108 -0.707106Z"
            fillRule="evenodd"
            transform="matrix(1 0 0 1 15.4998 4.49951)"
            fill="rgb(255, 255, 255)"
          />
          <path
            d="M-0.707106 -0.707107C-1.09763 -0.316587 -1.09763 0.316585 -0.707107 0.707106L2.79289 4.20711C3.18341 4.59763 3.81658 4.59763 4.2071 4.20711C4.59762 3.81659 4.59762 3.18341 4.2071 2.79289L0.707107 -0.707106C0.316587 -1.09763 -0.316585 -1.09763 -0.707106 -0.707107Z"
            fillRule="evenodd"
            transform="matrix(1 0 0 1 4.49975 15.9995)"
            fill="rgb(255, 255, 255)"
          />
          <path
            d="M11.7071 -0.707107C11.3166 -1.09763 10.6834 -1.09763 10.2929 -0.707107L-0.707107 10.2929C-1.09763 10.6834 -1.09763 11.3166 -0.707107 11.7071C-0.316586 12.0976 0.316586 12.0976 0.707107 11.7071L11.7071 0.707107C12.0976 0.316586 12.0976 -0.316586 11.7071 -0.707107Z"
            fillRule="evenodd"
            transform="matrix(1 0 0 1 6.49975 6.4995)"
            fill="rgb(255, 255, 255)"
          />
        </g>
      </g>
    </svg>
  );
};

export default PencilIcon;
